module.exports = __webpack_public_path__ + "static/faerie-dragon-5b05e8a5c72391b2bee08acb1b412c0b.jpg";